import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const CaregiverPermissionErrorModal = () => {
  const { t } = useTranslation('home');

  return <Text className="text-sm text-center text-theme-700">{t('U0008.description')}</Text>;
};

export default CaregiverPermissionErrorModal;
